module.exports = __webpack_public_path__ + "static/img/sunglasses.4461164.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/sunglasses.jpg
// module id = wOlw
// module chunks = 1